import { AVATAR_COLORS } from '../../../core/constants/global-constants';

export const avatarColor = (username: string) =>
  AVATAR_COLORS[(username.codePointAt(0) ?? 0) % AVATAR_COLORS.length];

export const getFirstName = (email: string): string => {
  const local = email.split('@')[0];
  const name = local.split('.')[0];

  return name.charAt(0).toUpperCase() + name.slice(1);
};
